import { FC, ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { isEqual } from "lodash-es";

import type { RootState } from "store";

// NOTE: The two auth guards below use intentionally different definitions of
// "authenticated" for identified users. This asymmetry is pre-existing behavior:
//   - UserIsNotAuthenticated: only fully verified users are "authenticated"
//   - UserIsAuthenticated: verified OR identified (so identified users can
//     reach fulfillment and be guided through verification by the journey)
// An identified user visiting /login triggers the logout() dispatch in LoginRoute,
// clearing their identified state. If UserIsNotAuthenticated redirected them away,
// that cleanup flow would never run.

export const UserIsAuthenticated: FC<{ children: ReactNode }> = ({ children }) => {
  const authState = useSelector((state: RootState) => state.authentication);
  const isAuth = isEqual(authState.authenticated, true) || authState.authLevel === "identified";
  return isAuth ? <>{children}</> : <Navigate to="/products/insurance/welcome" replace />;
};

export const UserIsNotAuthenticated: FC<{ children: ReactNode }> = ({ children }) => {
  const authState = useSelector((state: RootState) => state.authentication);
  const isAuth = isEqual(authState.authenticated, true);
  return isAuth ? <Navigate to="/" replace /> : <>{children}</>;
};
